import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { SiumpAnalise } from '../models/siump-analise.model';
import { FGTS_SIUMP_REPOSITORY } from '../repositories/fgts-siump.repository';

export const SIUMP_EXTENSOES_PERMITIDAS = ['ent', 'sai', 'txt'] as const;
export const SIUMP_TAMANHO_MAXIMO_BYTES = 2 * 1024 * 1024;

@Injectable({ providedIn: 'root' })
export class AnalisarArquivoSiumpUseCase {
  private readonly repository = inject(FGTS_SIUMP_REPOSITORY);

  /** Valida o arquivo no cliente (conveniência; a fronteira de segurança é o backend) e delega a análise. */
  execute(arquivo: File): Observable<SiumpAnalise> {
    const erro = AnalisarArquivoSiumpUseCase.validar(arquivo);
    return erro ? throwError(() => ({ error: { message: erro } })) : this.repository.analisarArquivo(arquivo);
  }

  static validar(arquivo: File): string | null {
    const extensao = arquivo.name.includes('.') ? arquivo.name.split('.').pop()!.toLowerCase() : '';
    if (!(SIUMP_EXTENSOES_PERMITIDAS as readonly string[]).includes(extensao)) {
      return 'Envie um arquivo com extensão .ENT, .SAI ou .TXT.';
    }
    if (arquivo.size === 0) {
      return 'O arquivo enviado está vazio.';
    }
    if (arquivo.size > SIUMP_TAMANHO_MAXIMO_BYTES) {
      return 'O arquivo excede o tamanho máximo permitido de 2 MB.';
    }
    return null;
  }
}
